var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CustomerName"),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.customerList,
                                placeholder: _vm.$t("customerNameText"),
                              },
                              model: {
                                value: _vm.queryParams.cusId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "cusId", $$v)
                                },
                                expression: "queryParams.cusId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "SKU" } },
                      [
                        _c("BjInputCode", {
                          attrs: { placeholder: "SKU" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessAfterCsgReturn.main.outRefundNo"
                          ),
                        },
                      },
                      [
                        _c("BjInputCode", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessAfterCsgReturn.main.outRefundNo"
                            ),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.outRefundNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "outRefundNo", $$v)
                            },
                            expression: "queryParams.outRefundNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseOrderDetail.table.associatedCode"
                          ),
                        },
                      },
                      [
                        _c("BjInputCode", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessPurchaseOrderDetail.table.associatedCode"
                            ),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.thirdCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "thirdCode", $$v)
                            },
                            expression: "queryParams.thirdCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("table.createTimeText") } },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            placeholder: _vm.$t("table.createTimeText"),
                          },
                          model: {
                            value: _vm.queryParamsTime_pay,
                            callback: function ($$v) {
                              _vm.queryParamsTime_pay = $$v
                            },
                            expression: "queryParamsTime_pay",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("fileSearch.table.UpdateTime") },
                      },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            placeholder: _vm.$t("fileSearch.table.UpdateTime"),
                          },
                          model: {
                            value: _vm.queryParamsUpdateTime_pay,
                            callback: function ($$v) {
                              _vm.queryParamsUpdateTime_pay = $$v
                            },
                            expression: "queryParamsUpdateTime_pay",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "el-col",
                      [
                        !_vm.$store.getters.cusId
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName:
                                      "v-permission:BusinessAfterCsgAdminReturnAdd",
                                    arg: "BusinessAfterCsgAdminReturnAdd",
                                  },
                                ],
                                staticClass: "main-btn",
                                attrs: { type: "primary" },
                                on: { click: _vm.onAdd },
                              },
                              [_vm._v(_vm._s(_vm.$t("addText")))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    false
                                      ? void 0
                                      : col.prop == "cusId"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerList.bjGet(row.cusId)
                                            )
                                          ),
                                        ]
                                      : col.prop === "outRefundNo"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDetail(row)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(row[col.prop]))]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: { copy: row[col.prop] },
                                          }),
                                        ]
                                      : col.prop === "creationDate"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeOperateTwoHour")(
                                                row[col.prop]
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "lastUpdateDate"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeOperateTwoHour")(
                                                row[col.prop]
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "status"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.RETURN_ORDER_STATUS.bjGet(
                                                  row[col.prop]
                                                )
                                              )
                                            )
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                row[col.prop],
                                                row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessAfterCsgAdminReturnView",
                                            arg: "BusinessAfterCsgAdminReturnView",
                                          },
                                        ],
                                        staticClass: "view-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDetail(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BusinessPurchaseOrderList.View"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    !_vm.OperationBtn.includes(row.status) &&
                                    !_vm.$store.getters.cusId
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:BusinessAfterCsgAdminReturnEdit",
                                                arg: "BusinessAfterCsgAdminReturnEdit",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEdit(row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("editText")))]
                                        )
                                      : _vm._e(),
                                    !_vm.OperationBtn.includes(row.status) &&
                                    !_vm.$store.getters.cusId
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onAbandon(row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BusinessPurchaseOrderList.Abandoned"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }